<template>
  <section id="pricing-plan" class=" ">
    <b-row class="pricing-card">
      <b-col sm="12" md="12" lg="12">
        <b-row>
          <template v-if="loading">
            <b-col
              lg="4"
              md="6"
              cols="12"
              class="d-flex"
              v-for="index in 3"
              :key="index"
            >
              <b-card no-body class="w-100 p-1">
                <div
                  class="w-100 d-flex flex-column justify-content-center align-items-center"
                >
                  <b-skeleton width="30%" height="100px" />
                  <b-skeleton width="40%" height="30px" class="mx-1 mb-2" />
                  <b-skeleton width="40%" height="40px" class="mx-1 mb-2" />
                </div>
                <b-list-group class="list-group-circle text-left mx-2">
                  <b-list-group-item v-for="i in 5" :key="i" class="py-50">
                    <b-skeleton width="60%" height="20px" />
                  </b-list-group-item>
                </b-list-group>
              </b-card>
            </b-col>
          </template>
          <template v-else-if="plans.length">
            <b-col class="d-flex align-items-center mb-1" lg="12">
              <div
                class="bg-warning rounded-lg mr-50"
                style="width: 4px; height: 15px; margin-bottom: 5px"
              ></div>
              <h5 class="text-white">plans</h5>
            </b-col>

            <b-col
              lg="4"
              md="6"
              cols="12"
              class="d-flex"
              v-for="(plan, index) in plans"
              :key="index"
            >
              <b-card
                align="center"
                class="popular w-100"
                :class="
                  userData &&
                  userData.plan &&
                  userData.plan.id &&
                  userData.plan.id === plan.id
                    ? 'bordered-green '
                    : ''
                "
              >
                <div
                  class="d-flex flex-column align-items-center justify-content-center"
                >
                  <div style="height: 220px" class="rounded-lg w-100" lg="12">
                    <b-img
                      style="max-height: 220px; width: 100%"
                      alt="basic svg img rounded-lg"
                      :src="
                        index == 0
                          ? require('@/assets/images/new-images-fx/forex-trading-1.png')
                          : index == 1
                          ? require('@/assets/images/new-images-fx/forex-trading-2.png')
                          : require('@/assets/images/new-images-fx/forex-trading-3.png')
                      "
                    />
                  </div>
                  <b-col
                    class="rounded-lg d-flex align-items-center p-1 justify-content-center"
                    lg="12"
                    style="
                      background-color: #262630;
                      width: 80%;
                      margin-top: -40px;
                      text-align: left;
                    "
                  >
                    <b-col
                      class="px-50 d-flex flex-column justify-content-center"
                      lg="6"
                    >
                      <b-img
                        class="mx-auto"
                        alt="basic svg img  "
                        width="100 "
                        :src="require('@/assets/images/fxlegends/logo2.png')"
                      />
                      <h4
                        class="font-weight-bolder mt-1 mb-0"
                        style="text-align: center"
                      >
                        {{ plan.name }}
                      </h4>
                    </b-col>
                    <!-- <b-col class="px-50" lg="6">
                      <h3 class="font-weight-bolder my-0">
                        50 <span style="color: #fbad25">%</span>
                      </h3>

                    </b-col> -->
                  </b-col>
                </div>

                <div class="annual-plan">
                  <div class="plan-price mt-2">
                    <span class="font-weight-bold" style="color: #f66395"
                      >$</span
                    >
                    <span
                      class="pricing-basic-value font-weight-bolder text-white"
                    >
                      {{ plan.fee }}
                    </span>
                    <sub
                      class="pricing-duration text-body font-medium-1 font-weight-bold"
                      >/month</sub
                    >
                  </div>
                </div>

                <b-list-group class="list-group-circle text-left mb-1">
                  <b-list-group-item
                    class="bottomBorder"
                    v-if="plan.first_month_competition"
                  >
                    {{ plan.first_month_competition }} free competitions first
                    month
                  </b-list-group-item>
                  <b-list-group-item
                    class="bottomBorder"
                    v-if="plan.monthly_competition"
                  >
                    {{
                      userData &&
                      userData.plan &&
                      userData.firts_month &&
                      userData.plan.first_month
                        ? plan.first_month_competition +
                          plan.monthly_competition
                        : plan.monthly_competition
                    }}
                    competition each month
                  </b-list-group-item>
                  <b-list-group-item
                    class="bottomBorder"
                    v-if="plan.chart_update_duration"
                  >
                    Competition chart update every
                    {{ plan.chart_update_duration }} hours
                  </b-list-group-item>
                  <b-list-group-item
                    class="bottomBorder"
                    v-if="plan.competition_max_participant"
                  >
                    {{ plan.competition_max_participant }} participant per
                    competition (maximum)
                  </b-list-group-item>
                  <b-list-group-item
                    class="bottomBorder"
                    v-if="plan.competition_max_participant"
                  >
                    {{ plan.competition_max_participant }} participant per
                    competition (maximum)
                  </b-list-group-item>
                  <b-list-group-item class="bottomBorder" v-if="plan.min_award">
                    {{ plan.min_award }}$ maximum prize pool per competition
                  </b-list-group-item>
                  <b-list-group-item
                    class=" "
                    v-if="plan.advance_user_analytics"
                  >
                    Advanced user data and analytics
                  </b-list-group-item>
                </b-list-group>
                <div class="w-100 left-0 text-center">
                  <!-- <b-button
                    v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                    variant="outline-light rounded-pill font-weight-bolder"
                    size="lg"
                  >
                    Current Plan
                  </b-button> -->
                  <b-button
                    class="w-100 btn-secondary bg-lighten-1"
                    size="lg"
                    :to="`/plans/${plan.id}/wallet`"
                    v-if="userData.type === 'admin'"
                  >
                    <feather-icon
                      icon="BookmarkIcon"
                      size="18"
                      style="margin-bottom: 2px"
                    />
                    wallet
                  </b-button>
                  <div v-if="userData.type === 'partner'">
                    <b-button
                      class="w-100 btn-secondary bg-lighten-1"
                      size="lg"
                      v-if="
                        userData &&
                        userData.plan &&
                        userData.plan.id &&
                        userData.plan.id === plan.id
                      "
                      disabled
                    >
                      This is your plan active
                      <br />
                      {{
                        plan.ended_at
                          ? "until" + " " + toLocal(plan.ended_at)
                          : ""
                      }}
                    </b-button>

                    <b-button
                      class="w-100 btn-secondary bg-lighten-1"
                      size="lg"
                      @click="
                        payItem = plan;
                        showPayModal = true;
                      "
                      v-else
                    >
                      <feather-icon
                        icon="BookmarkIcon"
                        size="18"
                        style="margin-bottom: 2px"
                      />
                      buy
                    </b-button>
                  </div>
                </div>
              </b-card>
            </b-col>
          </template>
        </b-row>
      </b-col>
    </b-row>
    <pay-modal
      payType="register"
      :item="payItem"
      :visible="showPayModal"
      v-model="showPayModal"
    />
  </section>
</template>

<script>
import {
  BFormCheckbox,
  BRow,
  BCol,
  BCard,
  BImg,
  BCardText,
  BListGroup,
  BListGroupItem,
  BButton,
  BBadge,
  BSkeleton,
} from "bootstrap-vue";
import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";
import Ripple from "vue-ripple-directive";
import PayModal from "@/views/panel/competitions/PayModal.vue";
/* eslint-disable global-require */

export default {
  components: {
    BFormCheckbox,
    BButton,
    BCardText,
    BListGroup,
    BListGroupItem,
    BRow,
    BCol,
    BCard,
    BBadge,
    BImg,
    AppCollapseItem,
    AppCollapse,
    BSkeleton,
    PayModal,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      payItem: {},
      showPayModal: false,
      plans: [],
      loading: false,
    };
  },
  async created() {
    this.loading = true;
    await this.getProfile();
    await this.getPlans();
    this.loading = false;
  },
  methods: {
    async getProfile() {
      try {
        if (this.userData.type == "partner") {
          const { data } = await this.$http.get(`/panel/profile/partner`);
          await localStorage.setItem(
            "userData",
            JSON.stringify({
              ...data.partner.data,
              documents: data.documents.data,
              type: "partner",
            })
          );
          await this.$store.dispatch("auth/setUserData", {
            ...data.partner.data,
            documents: data.documents.data,
            type: "partner",
          });
        } else {
          const { data } = await this.$http.get(`/panel/profile/user`);

          await localStorage.setItem(
            "userData",
            JSON.stringify({
              ...data.user,
              email_verified: data.user.email_verified_at ? true : false,
              type: data.abilities[0].includes("admin") ? "admin" : "user",
            })
          );
          await this.$store.dispatch("auth/setUserData", {
            ...data.user,
            email_verified: data.user.email_verified_at ? true : false,
            type: data.abilities[0].includes("admin") ? "admin" : "user",
          });
        }
      } catch (error) {}
    },
    async getPlans() {
      try {
        const { data } = await this.$http.get("/panel/plans");
        this.plans = data.data;
      } catch (err) {}
    },
  },
  computed: {
    userData() {
      return (
        this.$store.state.auth.userData ||
        JSON.parse(localStorage.getItem("userData"))
      );
    },
  },
};
/* eslint-disable global-require */
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-pricing.scss";
.bottomBorder {
  border-bottom: 1px dashed rgba(112, 112, 112, 0.27) !important;
  border-radius: 0;
}
.card.bordered-green {
  border: 1px solid #106f1080;
  box-shadow: 0 4px 24px 0 rgb(48 88 58 / 37%) !important;
}
</style>
